/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_DETAILS = `${ PREFIX_EVENTS_STORE }/SET_DETAILS`;
export const SET_DETAILS_POST_TYPE = `${ PREFIX_EVENTS_STORE }/SET_DETAILS_POST_TYPE`;
export const SET_DETAILS_IS_LOADING = `${ PREFIX_EVENTS_STORE }/SET_DETAILS_IS_LOADING`;
